import { render } from "./SkiCoachManagement.vue?vue&type=template&id=05f05231&scoped=true"
import script from "./SkiCoachManagement.vue?vue&type=script&lang=js"
export * from "./SkiCoachManagement.vue?vue&type=script&lang=js"

import "./SkiCoachManagement.vue?vue&type=style&index=0&id=05f05231&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f05231"]])

export default __exports__